import { v4 as uuidv4 } from 'uuid';

export type Guid = string;

export const EMPTY_GUID: Guid = '00000000-0000-0000-0000-000000000000';

export const createGuid = (): Guid => uuidv4();
